import { ReactComponent as TaskCompletedIcon } from 'assets/svgs/completed.svg';

export const TaskCompleted = TaskCompletedIcon;
